//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { metaData } from '~/configuration/metaData';
import LegalPageWrapper from '~/components/LegalPageWrapper.vue';
import navTypes from '~/store/constants/navTypes';

export default {
  name: 'ReturnPolicy',
  head: {
    ...metaData.returnPolicy,
  },
  components: {
    LegalPageWrapper,
  },
  mounted() {
    this.$store.commit('SET_NAV_TYPE', navTypes.legal);
  },
};
